import { SeoMetadata } from '../types'

export const WEBSITE_LOCALES = ['en-gb', 'en-us'] as const
export const WEBSITE_DEFAULT_LOCALE = 'en-gb'

export type WebsiteLocale = (typeof WEBSITE_LOCALES)[number]

export const localisedPages = ['/'] as const

export const homepageAlternateUrls = [
  ...WEBSITE_LOCALES.map((supportedLocale) => ({
    hreflang: supportedLocale,
    href: `${process.env.NEXT_PUBLIC_SITE_URL}/${supportedLocale}`,
  })),
  { hreflang: 'x-default', href: `${process.env.NEXT_PUBLIC_SITE_URL}` },
] as const

export const datoCMSLocales = ['en', 'en_US'] as const

export type DatoCMSLocale = (typeof datoCMSLocales)[number]

export interface LocaleSupportedPage {
  id: string
  metadata: SeoMetadata
}

export type LocalisedPages = Record<DatoCMSLocale, LocaleSupportedPage>

export type LocalisedPageProps = {
  localisedPages: LocalisedPages
}
